import { useAuth } from "oidc-react";
import { useState } from "react";
import { IdNamePair } from "../../customLists/customListView/CustomListView.types.ts";
import { useDotLegalPostGetQuery } from "@common/hooks/dotLegalReactQuery";
import { switchCustomerInStorage } from "../customerStorage";
import { Guid } from "@common/guid";

export function useDataMapping() {
    const auth = useAuth();
    const urlCustomerId = new URLSearchParams(window.location.search).get("customerId");

    // The token exchange reads the customer from localStorage, so suppressing the picker is not
    // enough: the URL parameter must be persisted or logins mapped to several customers fail.
    if (localStorage.getItem("customerId") === null && urlCustomerId && Guid.isGuid(urlCustomerId)) {
        switchCustomerInStorage(urlCustomerId);
    }

    const chooseCustomer = localStorage.getItem("customerId") === null;

    const [customerId, setCustomerId] = useState("");
    const [showDialog, setShowDialog] = useState(chooseCustomer);
    // auth.userData loads asynchronously; firing this before it's ready sends a tokenless request
    // that the backend cannot recover from, so the fetch must wait for the access token.
    const query = useDotLegalPostGetQuery<Array<IdNamePair>>(
        "/customerSelector",
        { token: auth.userData?.access_token },
        { enabled: chooseCustomer && !!auth.userData?.access_token }
    );

    function onCustomerChosen(id: string | null) {
        setShowDialog(false);
        if (id) {
            switchCustomerInStorage(id);
            setCustomerId(id);
        } else {
            auth.userManager.signoutRedirect();
        }
    }

    function onDialogClose() {
        setShowDialog(false);
        onCustomerChosen(null);
    }

    return {
        isLoading: query.isLoading,
        customers: query.data ?? [],
        onCustomerChosen,
        onDialogClose,
        showDialog: showDialog && (query.data?.length ?? 0) > 1,
    };
}
